// removed by extract-text-webpack-plugin
module.exports = {"productTitle":"qempo_CourierFlow_productTitle-38nX9Dv","inputControl":"qempo_CourierFlow_inputControl-gdVO5kj","textWrap":"qempo_CourierFlow_textWrap-DNT1Asf","titleWrap":"qempo_CourierFlow_titleWrap-1ZtPY9_","title":"qempo_CourierFlow_title-1KnVrGb","helperWrap":"qempo_CourierFlow_helperWrap-2JQwIqo","helperIcon":"qempo_CourierFlow_helperIcon-32D_rTu","loading":"qempo_CourierFlow_loading-381BhZG","report":"qempo_CourierFlow_report-2eY0Wcc","modalTitle":"qempo_CourierFlow_modalTitle-2RetF4-","amazonTrackingUrlImg":"qempo_CourierFlow_amazonTrackingUrlImg-JEtckpF"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Purchase/courier-flow/components/CourierFlow.scss
// module id = 1838
// module chunks = 0